/**
 * Rounds a money amount up to whole kopecks — the JS mirror of the backend's
 * `BigDecimal.setScale(2, RoundingMode.CEILING)`, which every price-bearing service in cmz-back
 * applies (CartXlsxService, OrderXlsxService, SpecificationXlsxService, RequestedProductsService,
 * SpecificationService, ProductElasticService). Cart figures must agree with the XLS the cart
 * itself exports, so they round the same way.
 *
 * Round once, at the end: the backend multiplies the raw price by the amount and only then sets the
 * scale, so a per-unit rounding here would drift by a kopeck per unit against the same export.
 *
 * The `toPrecision(12)` step is not cosmetic. A bare `Math.ceil(value * 100) / 100` inflates any
 * amount whose `value * 100` lands a float-epsilon above its integer — `0.07 * 100` is
 * `7.000000000000001`, so the bare form turns 0.07 into 0.08. Measured over the exact-kopeck values
 * from 0.01 to 20 000.00, it is wrong for 9 177 of the first 200 000; trimming to 12 significant
 * digits drops the noise (which lives in digits 16-17) at any magnitude, and is exact for all
 * 2 000 000 of them.
 */
export function ceilKopecks(value: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.ceil(Number((value * 100).toPrecision(12))) / 100;
}
